import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { PrintQR } from 'components/Cards';
import { useStore } from 'store';
import styles from './styles.module.sass'


const MenuMultiButons = (props) => {
    const {
        handleInLine,
        linea
    } = props

    const history = useHistory();
    const contrato_virtual = 'https://resources.sears.com.mx/medios-plazavip/swift/v1/mesaRegalos/CONTRATO-PLAN-VIRTUAL.pdf'
    const contrato_fisica = 'https://resources.sears.com.mx/medios-plazavip/swift/v1/mesaRegalos/CONTATO-PLAN-LO-QUIERO.pdf'
    const [giftTable, ] = useStore((state) => state.giftTable.giftTable)
    const [ getOpenModal, setOpenModal ] = useState(false)
    const [ plan, setPlan ] = useState()

    const section = window.location.pathname
    
    const handleMiMesa = (noEvent) => {
        if(section.indexOf('/my-table') >= 0 ){
            handleInLine(noEvent)
        }else{
            history.push(`/my-table?event=${noEvent}`)
        }
    }
    const handleAddProduct = () => {
        history.push('/agregar-regalos')
    }

    const handleGiftsRecived = () => {
        history.push('/regalos-recibidos')
    }

    const handleDatosEvento = (noEvent) => {
        if(section.indexOf('/my-table') >= 0 ){
            handleInLine(noEvent)
        }else{
            history.push(`/my-table?event=${noEvent}`)
        }
    }

    const handleCoupon = (noEvent) => {
        if(section.indexOf('/my-table') >= 0 ){
            handleInLine(noEvent)
        }else{
            history.push(`/my-table?event=${noEvent}`)
        }
    }

    const handleShare = () => {
        setOpenModal(true)
    }
    const handleCloseModal = () => {
        setOpenModal(false);
    };

    useEffect(()=>{
        if(giftTable?.plan?.name){
            setPlan(giftTable?.plan?.name)
        }
    },[giftTable])

    return(
        <>
            <div className={styles?.contMultiBtns}>
                <div className={styles?.contBtns}>
                    <div
                        className={linea === 1 ? 'btn primaryButton' : 'btn secondaryButton'}
                        onClick={() => handleMiMesa(1) }
                        aria-hidden
                    >Mi Mesa</div>

                    <div
                        className={linea === 10 ? 'btn primaryButton' : 'btn secondaryButton'}
                        onClick={() => handleAddProduct()}
                        aria-hidden
                    >Agregar regalos</div>

                    <div
                        className={linea === 11 ? 'btn primaryButton' : 'btn secondaryButton'}
                        onClick={() => handleGiftsRecived()}
                        aria-hidden
                    >Regalos recibidos</div>

                    {giftTable?.applyBonification
                        ?
                            <div
                                onClick={() => handleCoupon(4)}
                                className={linea === 4 ? 'btn primaryButton' : 'btn secondaryButton'}
                                aria-hidden
                                >Mi cupón</div>
                            : null
                    }
                </div>

                <div className={styles?.contBtns}>
                    <p
                        onClick={() => handleDatosEvento(3)}
                        className={linea !== 3 ? styles?.btnLinks : `${styles?.btnLinks} ${styles?.active}`}
                        aria-hidden
                        >Datos del evento</p>

                    <p
                        onClick={() => handleShare()}
                        className={styles?.btnLinks}
                        aria-hidden
                        >Compartir</p>
                    <a 
                        href={plan  === 'VIRTUAL' ? contrato_virtual : contrato_fisica}
                        target='_blank' 
                        download 
                        className={styles?.btnLinks}
                        rel="noreferrer"
                        aria-hidden
                    >Términos y condiciones</a>
                </div>
            </div>

            {getOpenModal
                ? <PrintQR variant="none" getOpenModal={getOpenModal} closeModal={handleCloseModal}  />
                : null
            }
        </>
    )
}

export default MenuMultiButons